import * as React from 'react'
import { View, Text, TouchableOpacity, Image } from 'react-native';
import { useTheme } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import AsyncStorage from '@react-native-async-storage/async-storage'

export default React.memo(function MyTabBar({ state, descriptors, navigation }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [merchant, setMerchant] = React.useState()
    const focusedOptions = descriptors[state.routes[state.index].key].options
    if (focusedOptions.tabBarVisible === false) {
        return null
    }

    React.useEffect(() => {
        const restoreState = async () => {
            try {
                const tmp_ = await AsyncStorage.getItem('merchant')
                let item = null
                if (tmp_) item = JSON.parse(tmp_)
                setMerchant(item)
            } catch (error) {
                console.log(error)
            }
        }
        if (!merchant) {
            restoreState()
        }
    }, [])

    return (
        <View style={{ flexDirection: 'row', borderTopWidth: 2, borderTopColor: merchant?.color }}>
            {state.routes.map((route, index) => {
                const { options } = descriptors[route.key];
                const label =
                    options.tabBarLabel !== undefined
                        ? options.tabBarLabel
                        : options.title !== undefined
                            ? options.title
                            : route.name;

                const isFocused = state.index === index;

                const onPress = () => {
                    const event = navigation.emit({
                        type: 'tabPress',
                        target: route.key,
                        canPreventDefault: true,
                    });

                    if (!isFocused && !event.defaultPrevented) {
                        navigation.navigate(route.name);
                    }
                };

                const onLongPress = () => {
                    navigation.emit({
                        type: 'tabLongPress',
                        target: route.key,
                    });
                };

                return (
                    <TouchableOpacity
                        accessibilityRole="button"
                        accessibilityState={isFocused ? { selected: true } : {}}
                        accessibilityLabel={options.tabBarAccessibilityLabel}
                        testID={options.tabBarTestID}
                        onPress={onPress}
                        onLongPress={onLongPress}
                        style={{ flex: 1, backgroundColor: '#FFFFFF', flexDirection: 'column', paddingBottom: insets.bottom }} key={index}>
                        <View style={{ height: 60, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                            <Image source={options.tabBarImage} style={{ width: 25, height: 25, tintColor: isFocused ? merchant?.color : '#8F99BA' }} />
                            <Text style={{
                                color: isFocused ? merchant?.color : '#8F99BA', fontSize: 12, fontFamily: isFocused ? 'Nunito_700Bold' : 'Nunito_400Regular',
                                textAlign: 'center', marginTop: 3
                            }}>{label}</Text>
                        </View>
                    </TouchableOpacity>
                );
            })}
        </View>
    )
})